import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSelectCheckBox = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H15.8333C15.9444 2.5 16.0486 2.51042 16.1458 2.53125C16.2431 2.55208 16.3403 2.58333 16.4375 2.625L14.8958 4.16667H4.16667V15.8333H15.8333V10.2917L17.5 8.625V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H4.16667ZM9.60417 14.1667L4.89583 9.45833L6.0625 8.29167L9.60417 11.8333L17.25 4.1875L18.4375 5.33333L9.60417 14.1667Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgSelectCheckBox);
export default ForwardRef;
